<template>
  <WdsStack direction-column gap-lg align-center>
    <WdsAvatar xxl :path="randomAvatar" />

    <WdsStack direction-column gap-xs align-center>
      <WdsText xl2 primary>{{ $t(`This is embarrassing, we couldn't load this content`) }}</WdsText>

      <WdsText xl tertiary>
        {{ $t('Please try refreshing the page or check our platform status for any known issues') }}
      </WdsText>
      <WdsText v-if="hasData" xl tertiary>
        {{
          $t(
            'Or try to load the data we have received regardless off the error that may have occurred',
          )
        }}
      </WdsText>
    </WdsStack>

    <WdsStack direction-row gap-md>
      <a href="https://status.worksome.com" target="_blank">
        <WdsButton lg secondary>{{ $t('Check platform status') }}</WdsButton>
      </a>
      <WdsButton v-if="hasData" lg warning-subtle @click="$emit('loadData')">
        {{ $t('Attempt to load data') }}
      </WdsButton>
      <WdsButton lg primary @click="refreshPage">{{ $t('Refresh page') }}</WdsButton>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsAvatar, WdsButton, WdsStack, WdsText } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { getRandomAvatarPath } from '@/utils/avatar'

const randomAvatar = getRandomAvatarPath()

defineEmits<{ loadData: [] }>()

const refreshPage = () => {
  window.location.reload()
}

withDefaults(
  defineProps<{
    hasData: boolean
  }>(),
  {
    hasData: false,
  },
)
</script>
